<span class="_container"
      [class]="method || ''"></span>